<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100"> 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi">
    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Koti</h2>
            <button class="btn btn-formed-main-blue" (click)="getRealTimeData()">Päivitä</button>
        </div>
        <div class="col-1"></div>
    </div>
    <div class="col-12 row">
        <div class="col-1">

        </div>
        <div class="col-10">

            <div class="" *ngIf="data && data.users">
                <h2>Käyttäjät</h2>
                <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                        <tr>
                            <th>Ryhmä</th>
                            <th>hlö</th>
                            <th>%kaikista</th>
        
                        </tr>
                    </thead>
                    <tbody class="tbody-light">
                        <tr>
                            <tr>
                                <th width="33%">Hammas</th>
                                <td width="33%">{{data.users.number_of_dental}}</td>
                                <td width="33%">{{(data.users.number_of_dental / data.users.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Lääkäreitä</th>
                                <td width="33%">{{data.users.number_of_doctors}}</td>
                                <td width="33%">{{(data.users.number_of_doctors / data.users.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Hoitajia</th>
                                <td width="33%">{{data.users.number_of_nurses}}</td>
                                <td width="33%">{{(data.users.number_of_nurses / data.users.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Sosiaali</th>
                                <td width="33%">{{data.users.number_of_social}}</td>
                                <td width="33%">{{(data.users.number_of_social / data.users.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Erikoistuvia</th>
                                <td width="33%">{{data.users.number_of_specialists}}</td>
                                <td width="33%">{{(data.users.number_of_specialists / data.users.total  * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Opiskelijoita</th>
                                <td width="33%">{{data.users.number_of_students}}</td>
                                <td width="33%">{{(data.users.number_of_students / data.users.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Käyttäjiä yhteensä</th>
                                <td width="33%">{{data.users.total}}</td>
                                <td width="33%">{{(data.users.total / data.users.total * 100).toFixed(2)}}%</td>
                            </tr>
        
        
                    </tbody>
        
                </table>
            </div>
            <div class="" *ngIf="data && data.users">
                <h2>Työpaikat</h2>
                <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                        <tr>
                            <th>Tieto</th>
                            <th>kpl (näkyvissä)</th>
                            <th>%kaikista</th>
                        </tr>
                    </thead>
                    <tbody class="tbody-light">

                            <tr>
                                <th width="33%">Hammas </th>
                                <td width="33%">{{data.openings.number_of_dental}} ({{data.openings.visible_dental}})</td>
                                <td width="33%">{{(data.openings.number_of_dental / data.openings.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Lääkäri </th>
                                <td width="33%">{{data.openings.number_of_doctors}} ({{data.openings.visible_doctors}})</td>
                                <td width="33%">{{(data.openings.number_of_doctors / data.openings.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Hoitaja </th>
                                <td width="33%">{{data.openings.number_of_nurses}} ({{data.openings.visible_nurses}})</td>
                                <td width="33%">{{(data.openings.number_of_nurses /data.openings.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Sosiaaliala </th>
                                <td width="33%">{{data.openings.number_of_social}} ({{data.openings.visible_social}})</td>
                                <td width="33%">{{(data.openings.number_of_social / data.openings.total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%"> yhteensä</th>
                                <td width="33%">{{data.openings.total}} ({{data.openings.visible_total}})</td>
                                <td width="33%">{{(data.openings.total / data.openings.total * 100).toFixed(2)}}%</td>
                            </tr>
        
        
                    </tbody>
        
                </table>
            </div>
            <div class="mb-4 pb-4" *ngIf="data && data.users">
                <h2>Toiveet</h2>
                <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                        <tr>
                            <th>Tieto</th>
                            <th>kpl (ratio)</th>
                            <th>%kaikista</th>
                        </tr>
                    </thead>
                    <tbody class="tbody-light">

                            <tr>
                                <th width="33%">Hammas</th>
                                <td width="33%">{{data.wishes.number_of_dental}} ({{(data.wishes.number_of_dental / data.users.number_of_dental* 100).toFixed(2)}}%)</td>
                                <td width="33%">{{(data.wishes.number_of_dental / data.wishes.total* 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Lääkäri</th>
                                <td width="33%">{{data.wishes.number_of_doctors}} ({{(data.wishes.number_of_doctors / data.users.number_of_doctors* 100).toFixed(2)}}%)</td>
                                <td width="33%">{{(data.wishes.number_of_doctors / data.wishes.total* 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Hoitaja</th>
                                <td width="33%">{{data.wishes.number_of_nurses}} ({{(data.wishes.number_of_nurses / data.users.number_of_nurses* 100).toFixed(2)}}%)</td>
                                <td width="33%">{{(data.wishes.number_of_nurses / data.wishes.total* 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Sosiaaliala</th>
                                <td width="33%">{{data.wishes.number_of_social}} ({{(data.wishes.number_of_social / data.users.number_of_social* 100).toFixed(2)}}%)</td>
                                <td width="33%">{{(data.wishes.number_of_social / data.wishes.total* 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Yhteensä</th>
                                <td width="33%">{{data.wishes.total}}</td>
                                <td width="33%">{{(data.wishes.total / data.wishes.total* 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Wish-User Ratio</th>
                                <td width="33%">{{(data.wishes.total / data.users.total * 100).toFixed(2)}}%</td>
                            </tr>
        
        
                    </tbody>
        
                </table>
            </div>
            <div class="" *ngIf="data && data.users">
                <h2>Käyttäjät Aktiivisuus rullaava 24h</h2>
                <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                        <tr>
                            <th>Ryhmä</th>
                            <th>hlö</th>
                            <th>%kaikista</th>
        
                        </tr>
                    </thead>
                    <tbody class="tbody-light">
                        <tr>
                            <tr>
                                <th width="33%">Hammas</th>
                                <td width="33%">{{data.users.active_dental}}</td>
                                <td width="33%">{{(data.users.active_dental / data.users.active_total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Lääkäreitä</th>
                                <td width="33%">{{data.users.active_doctors}}</td>
                                <td width="33%">{{(data.users.active_doctors / data.users.active_total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Hoitajia</th>
                                <td width="33%">{{data.users.active_nurses}}</td>
                                <td width="33%">{{(data.users.active_nurses / data.users.active_total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Sosiaali</th>
                                <td width="33%">{{data.users.active_social}}</td>
                                <td width="33%">{{(data.users.active_social / data.users.active_total * 100).toFixed(2)}}%</td>
                            </tr>
                            <tr>
                                <th width="33%">Käyttäjiä yhteensä</th>
                                <td width="33%">{{data.users.active_total}}</td>
                                <td width="33%">{{(data.users.active_total / data.users.active_total * 100).toFixed(2)}}%</td>
                            </tr>
        
        
                    </tbody>
        
                </table>
            </div>
            
        </div>
        <div class="col-1">

        </div>
    </div>

  
  

  </div>

    </div>